import request from '@/utils/request'
const HomeApi = {
  queryPublicContent: (params) => {
    return request({
      url: `/public/content`,
      method: 'get',
      params
    })
  },
  queryExchangeRankingList: (params) => {
    return request({
      url: '/exchange-ranking/list',
      method: 'get',
      params
    })
  },
  queryPublicNoticeList: () => {
    return request({
      url: '/public/notice/list',
      method: 'get'
    })
  },
  getCassLoginHelpImg: (data) => {
    return request({
      url: '/public/apply/image',
      method: 'post',
      data
    })
  },
  getNoticeInfo: (params) => {
    return request({
      url: '/public/notice/info/' + params,
      method: 'get'
    })
  }
}

export default HomeApi
